export default __webpack_public_path__ + "static/media/pay.8df80031.svg";